// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

/// 单例
import store from './store'


// import Navigation from 'vue-navigation'
// Vue.use(Navigation,{router, store , moduleName: 'navigation'});

import './assets/less/common.less'
import 'animate.css'

import login from "./components/login"; // 登录弹窗全局组件
Vue.prototype.$login = login.install; // 全局可使用this.$login调用


Vue.config.productionTip = false


Vue.prototype.$exchangeRate = 1.2

new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
})




// WEBPACK FOOTER //
// ./src/main.js